import type { JSX } from 'react'
import { SEARCH_HIGHLIGHT_CLASS } from '#src/components/core/searchHighlight.ts'
import { highlightMatches } from '#src/hooks/useClientSideSearch.ts'

/* Paired with `useClientSideSearch`: pass `matchById.get(id)?.terms` to
 * highlight the user's query inside visible table cells. */
export function HighlightedText({
  text,
  terms,
  className,
}: {
  text: string | null | undefined
  terms: string[] | undefined
  className?: string
}): JSX.Element {
  const value = text ?? ''
  if (!terms || terms.length === 0) {
    return <span className={className}>{value}</span>
  }
  const parts = highlightMatches(value, terms)
  return (
    <span className={className}>
      {parts.map((part, i) =>
        typeof part === 'string' ? (
          part
        ) : (
          <mark
            // oxlint-disable-next-line react/no-array-index-key -- positional parts from a single string are stable by index
            key={i}
            className={SEARCH_HIGHLIGHT_CLASS}
          >
            {part.mark}
          </mark>
        )
      )}
    </span>
  )
}
